import { Injectable, NgModule } from '@angular/core';
import { RouterModule, RouterStateSnapshot, Routes, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { getFlavorName } from './core/utils';

export const HOME_URL = '/home';
export const UNAUTHORIZED_URL = '/unauthorized';
export const AUTH_LOGIN_URL = `/auth/login`;
export const AUTH_PROCESS_URL = `auth/:authType/process`;
export const ONBOARD_TEAM_MICROSOFT_SITES = 'microsoft/sites';

const routes: Routes = [
  // If URL is empty redirect to `defaultUrl`
  {
    path: '',
    pathMatch: 'full',
    redirectTo: HOME_URL,
  },

  // Deep Links
  {
    path: 'dl',
    children: [
      {
        path: 'accept-invite',
        pathMatch: 'full',
        redirectTo: '/',
      },
    ],
  },

  // Public
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/feed-public/feed-public.module').then((m) => m.FeedPublicModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/gallery-public/gallery-public.module').then((m) => m.GalleryPublicModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/embedded-login/embedded-login.module').then((m) => m.EmbeddedLoginModule),
  },
  {
    path: '',
    loadChildren: () => import('./features/reports/reports.module').then((m) => m.ReportsModule),
  },

  // Protected
  {
    path: '',
    loadChildren: () =>
      import('./features/protected/protected.module').then((m) => m.ProtectedModule),
  },

  // For everything else (catch-all) redirect to "HOME"
  {
    path: '**',
    redirectTo: HOME_URL,
  },
];

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);

    if (title !== undefined) {
      this.title.setTitle(`${title} · ${getFlavorName()}`);
    }
  }
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: TitleStrategy, useClass: TemplatePageTitleStrategy }],
})
export class AppRoutingModule {}
